<template>
  <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
          <v-btn v-on="on">
              {{ $t('View terms and conditions') }}
          </v-btn>
      </template>

      <v-card>
          <v-card-title class="headline grey lighten-2"
                  primary-title>
              {{ $t('Terms and conditions') }}
          </v-card-title>

          <v-card-text v-if="lang==='nl'">
            <h3>Bijzondere voorwaarden</h3>
            <p>De inzender/exposant verklaart dat hij door inschrijving de rechtsmacht van de Vereniging Raad van
            Beheer op Kynologisch Gebied in Nederland en de werking van het Kynologisch Reglement aanvaardt
              en geacht mag worden bekend te zijn met dit reglement.</p>
            <p>De inzender/exposant verklaart dat de ingeschreven hond, voor zover hem bekend is, gedurende de
            laatste twaalf weken niet heeft verkeerd in de omstandigheden waardoor gevaar op besmetting te
            vrezen valt en dat hij de hond niet zal inzenden indien de bedoelde omstandigheden zich alsnog
              mochten voordoen.</p>
            <p>Door inzending van het inschrijfformulier verplicht de inzender/exposant zich om het inschrijfgeld
              tegelijkertijd met de inschrijving te voldoen.</p>
            <p>Online inschrijven staat gelijk aan ondertekenen en is daarmee uw akkoord met de gestelde regels.
            Bij inschrijving stemt u in met het feit dat uw gegevens in het kader van de Wet Bescherming
            Persoonsgegevens wordt verstrekt ten behoeve van de tentoonstelling en ten behoeve van
              activiteiten van de Raad van Beheer.</p>
            <h3>(Verplichte) Entingen en EU Dierenpaspoort:</h3>
            <p>Alle op de tentoonstelling aanwezige honden (incl. bezoekhonden en/of demonstratiehonden)
            moeten middels het inentingsboekje/ Europees hondenpaspoort aan kunnen tonen dat de hond
            voldoende is beschermd middels enting of middels titerbepaling (met einddatum aangegeven door
              een praktiserend dierenarts in het Europees hondenpaspoort).</p>
            <h3>Schade:</h3>
            <p>Iedere deelnemer is persoonlijk verantwoordelijk voor de schade die door hem / haar of zijn / haar
            hond(en) wordt toegebracht. Deze schade kan nimmer op de organisator c.q. het bestuur c.q. de club
              worden verhaald. De club wijst in deze elke aansprakelijkheid af.</p>
            <h3>Overmacht:</h3>
            <p>Wanneer door overmacht de tentoonstelling niet door kan gaan, vindt geen volledige restitutie van
            het inschrijfgeld plaats. Wanneer u zelf door overmacht niet aanwezig kunt zijn op de
              tentoonstelling, vindt geen restitutie van inschrijfgeld plaats.</p>
            <h3>Foto’s:</h3>
            <p>Foto's die tijdens de tentoonstelling door de clubfotograaf worden gemaakt, kunnen worden
            gebruikt voor promotionele doeleinden.</p>
          </v-card-text>
        <v-card-text v-if="lang === 'en'">
          <h3>Special Conditions</h3>
          <p>
          The entrant / exhibitor declares that by registering he accepts the jurisdiction of the Raad van
          Beheer op Kynologisch Gebied in Nederland and the operation of the Kynological
          Regulations and may be deemed to be familiar with these regulations.
          </p>
          <p>
          The entrant / exhibitor declares that during the last twelve weeks the registered dog, as far
          as he is aware, has not been in the circumstances that could cause a risk of infection and
          that he will not enter the dog if the aforementioned circumstances should occur.</p>
          <p>By submitting the registration form, the entrant / exhibitor undertakes to pay the registration
          fee at the same time as the registration.</p>
          <p>Registering online is equivalent to signing and is therefore your agreement with the set rules.
          When registering, you agree to the fact that your data is provided for the purpose of the
            exhibition and for the activities of the Raad van Beheer under the Dutch Data Protection Act.</p>
          <h3>(Compulsory) Vaccinations and EU Pet Passport:</h3>
          <p>All dogs present at the exhibition (incl. visiting dogs and / or demonstration dogs) must be
          able to demonstrate by means of the vaccination booklet / European dog passport that the
          dog is sufficiently protected by vaccination or titer determination (with end date indicated by a
            practicing veterinarian in the European dog passport).</p>
          <h3>Damage:</h3>
          <p>Every participant is personally responsible for the damage caused by him / her or his / her
          dog (s). This damage can never be recovered from the organizer or the board or the club.
            The club disclaims any liability in this regard.</p>
          <h3>Force majeure:</h3>
          <p>If the exhibition cannot take place due to force majeure, the registration fee will not be fully
          refunded. If you are unable to attend the exhibition due to force majeure, there will be no
            refund of registration fees.</p>
          <h3>Photos:</h3>
          <p>
          Photos taken by the club photographer during the exhibition can be used for promotional
          purposes.</p>
        </v-card-text>
          <v-card-text v-if="lang === 'de'">
            <h3>Besondere Bedingungen</h3>
            <p>
            Der Teilnehmer/Aussteller erklärt, dass durch Anmeldung, er durch die Rechtsprechung vom
            Vorstand in den Niederlanden vom „Raad van Beheer“ für die Aktivitäten der Kynologischen Regeln
            und Vorschriften akzeptiert und berücksichtigt, vertraut zu sein mit diesen Regeln und Vorschriften.
            </p>
            <p>Der Teilnehmer/Aussteller erklärt, das der gemeldete Hund, soweit ihm bekannt ist, während der
            letzten 12 Wochen kein Gesundheitsrisiko einer Infektion zu befürchten hatte, und dass er den Hund
            nicht ausstellen wird, wenn dies als noch auftritt.</p>
            <p>Durch die Anmeldung mittels dem Anmeldeformular verpflichtet sich der Teilnehmer/Aussteller um
              zur gleichen Zeit die Anmeldegebühr zu erstatten.</p>
            <p>Die Online Anmeldung ist gleichbedeutend mit Unterzeichnung und wird als Ihre Zustimmung der
              festgelegten Regeln gesehen.</p>
            <p>Mit der Anmeldung akzeptieren Sie die Bedingungen mit der Tatsache, dass Ihre Daten im Rahmen
            des Gesetzes über den Schutz Personenbezogener Daten für die Zwecke der Ausstellung und für die
              Zwecke der Aktivitäten zur Verfügung gestellt werden an den „Raad van Beheer“.</p>
            <h3>(Erforderlich) Impfungen und EU-Heimtierausweis:</h3>
            <p>
            Alle auf dem Ausstellungsgelände anwesenden Hunde (einschl. Besucherhunde und/oder
            Demonstrationshunde) sind, durch Impfung/ European Dog Pass, in der Lage zu beweisen, dass der
            Hund ausreichend geschützt ist durch eine Impfung oder durch eine Titer Bestimmung (mit dem
            Ende, gekennzeichnet durch einen Praktizierenden Tierarzt im EU Hunde Ausweis).
            </p>

            <h3>Schäden/Haftung:</h3>
            <p>Die Eigentümer der ausgestellten Hunde haften für alle Schäden, die durch ihre Hunde angerichtet
            werden und können niemals vom Veranstalter, Club, Vorstand vom Club erstattet werden. Der
              Verein übernimmt keinerlei Haftung.</p>
            <h3>Höhere Gewalt:</h3>
            <p>
            Wenn die Ausstellung infolge höherer Gewalt keinen Durchgang haben kann, erfolgt keine
            Rückerstattung der Teilnahmegebühr. Wenn der Teilnehmer/Aussteller nicht auf der Ausstellung
            infolge höherer Gewalt erscheinen kann, erfolgt keine Rückerstattung der Teilnahmegebühr.</p>
            <h3>Fotos:</h3>
            <p>Fotos welche während dieser öffentlichen Ausstellung vom Club Fotografen gemacht werden,
              können für Werbezwecke und/oder Internetpräsenz verwendet werden.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                      color="primary"
                      flat
                      @click="dialog=false">
                  {{ $t('Close') }}
              </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'TermsAndConditions',
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    lang: {
      type: String,
      default: 'en',
    },
  },
};
</script>
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>



// WEBPACK FOOTER //
// src/components/TermsAndConditions.vue